/* NOCTIVELLE, script du panier. Source : snippets/noctivelle-panier.liquid jusqu'au 18 septembre 2026,
   sorti en asset pour alleger le HTML et se charger en differe (defer). */
(function(){
  var HANDLE = 'le-coussin-noctivelle';
  /* Le bouton pack duo mene au bloc d'achat de l'ACCUEIL, comme "Voir le
     coussin" du panier vide : meme lien, meme calage, celui qui marche.
     Une matinee a viser le bloc couleurs de la fiche (13 septembre 2026) :
     le tiroir memorise a partir de 990 px, sa fermeture qui remet la page en
     haut, le bloc deplace apres coup... Nathanael a tranche : on change la
     destination, pas la mecanique. */
  var URL_FICHE = '/#nv-produit';

  function clone(id){
    var t = document.getElementById(id);
    return (t && t.content) ? t.content.cloneNode(true) : null;
  }

  /* ---------- ouverture du tiroir apres un ajout ---------- */
  function ouvrirTiroir(){
    var t = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (t){ t.click(); return true; }
    return false;
  }

  /* filet de secours du rechargement : on remet la page ou elle etait */
  try{
    if (sessionStorage.getItem('nvOuvrirPanier')){
      sessionStorage.removeItem('nvOuvrirPanier');
      var y = parseInt(sessionStorage.getItem('nvScroll') || '0', 10);
      sessionStorage.removeItem('nvScroll');
      window.addEventListener('load', function(){
        if (y > 0) window.scrollTo(0, y);
        setTimeout(ouvrirTiroir, 150);
      });
    }
  }catch(e){}

  /* ---------- ajout au panier ---------- */
  function variante(depuis){
    var boite = depuis.closest('form') || depuis.closest('.nv-prodbloc') || document;
    var coche = boite.querySelector('input[name="id"]:checked') || boite.querySelector('input[name="id"]');
    return coche ? coche.value : null;
  }

  /* ---------- LE COUSSIN DE PLUS SUR SA PROPRE LIGNE, 13 septembre 2026 ----------
     Demande de Nathanael : au-dela de deux coussins, le panier doit montrer
     une ligne a part, "1 coussin de plus", au lieu d'une seule ligne x3 avec
     un prix unitaire moyen que personne ne comprend.
     Shopify fusionne les variantes identiques sur une seule ligne. Pour en
     ouvrir une deuxieme, on ajoute le coussin avec une propriete de ligne,
     _nv_extra (le tiret bas la cache au paiement). Regle : des que le panier
     contient deja deux coussins "de base" (sans la propriete), tout ajout
     part sur la ligne extra. Trois chemins d'ajout, tous couverts :
       - nos boutons data-nv-add (blocs d'achat)          : ici, ajouter()
       - le formulaire natif d'Horizon sur la fiche         : un champ cache
         properties[_nv_extra] pose/retire a chaque lecture du panier
       - le "+" de la ligne de base dans le tiroir          : intercepte, il
         ajoute sur la ligne extra au lieu d'incrementer
     La remise duo (14 EUR des 2) reste repartie par Shopify sur toutes les
     lignes au prorata ; l'AFFICHAGE la remet entierement sur la ligne de base
     (voir cart-products). Le total, lui, est toujours juste. */
  var EXTRA = '_nv_extra';
  var dernierPanier = null;

  function estExtra(it){ return !!(it && it.properties && it.properties[EXTRA]); }

  function qteBase(panier){
    var n = 0;
    ((panier && panier.items) || []).forEach(function(it){
      if (it.handle === HANDLE && !estExtra(it)) n += it.quantity;
    });
    return n;
  }

  function lirePanier(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ dernierPanier = c; return c; });
  }

  function changer(key, qte){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qte })
    });
  }

  function prevenirHorizon(c){
    var ev = new Event('shopify:cart:lines-update', { bubbles: true });
    ev.action = 'change';
    ev.promise = Promise.resolve({ detail: { itemCount: (c && c.item_count) || 0 } });
    document.dispatchEvent(ev);
  }

  /* REMISE EN ORDRE DES LIGNES, 13 septembre 2026. Bug vu par Nathanael :
     quatre coussins (2 de base + 2 "de plus"), il supprime la ligne duo, et
     les deux restants s'affichent plein tarif. Shopify, lui, leur donne bien
     la remise (des 2, quelle que soit la ligne), mais notre affichage
     considere la ligne extra comme hors duo. Regle : la ligne de base porte
     toujours les deux premiers coussins. Si elle en a moins de deux et qu'une
     ligne extra existe, on y rapatrie ce qui manque ; si elle en a plus de
     deux (quantite tapee a la main), on renvoie l'excedent sur la ligne
     extra. Une seule operation par lecture ; la relecture qui suit fait le
     reste s'il en faut. Le drapeau evite deux remises en ordre en meme temps. */
  var remiseEnOrdre = false;

  function normaliser(c){
    if (remiseEnOrdre) return Promise.resolve(false);
    var bases = [], extras = [], base = 0;
    (c.items || []).forEach(function(it){
      if (it.handle !== HANDLE) return;
      if (estExtra(it)) extras.push(it); else { bases.push(it); base += it.quantity; }
    });
    var op = null;
    if (base < 2 && extras.length){
      var ex = extras[0], manque = Math.min(2 - base, ex.quantity);
      op = changer(ex.key, ex.quantity - manque).then(function(){ return ajouter(ex.variant_id, manque, false); });
    } else if (base > 2 && bases.length === 1){
      var b = bases[0], trop = b.quantity - 2;
      op = changer(b.key, 2).then(function(){ return ajouter(b.variant_id, trop, true); });
    }
    if (!op) return Promise.resolve(false);
    remiseEnOrdre = true;
    return op.then(function(){ return true; }).catch(function(){ return false; })
      .then(function(fait){ remiseEnOrdre = false; return fait; });
  }

  function poster(lignes){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: lignes })
    });
  }

  function ajouter(id, qte, extra){
    var ligne = { id: id, quantity: qte || 1 };
    if (extra){ ligne.properties = {}; ligne.properties[EXTRA] = 'oui'; }
    return poster([ligne]);
  }

  /* ---------- LE PALIER CHOISI, 22 septembre 2026 ----------
     Le bloc d'achat propose 1, 2 ou 3 coussins (noctivelle-packs). Le bouton
     ajoute donc la quantite cochee, en un seul appel, et la regle des lignes
     ne change pas : la ligne de base porte au plus deux coussins, le reste
     part sur la ligne _nv_extra. Pour trois coussins dans un panier vide,
     c'est une requete avec deux lignes, pas trois allers-retours. */
  function qteChoisie(depuis){
    var boite = depuis.closest('form') || depuis.closest('.nv-prodbloc') || document;
    var r = boite.querySelector('[data-nv-qte]:checked');
    var n = r ? parseInt(r.value, 10) : 1;
    return (n >= 1 && n <= 9) ? n : 1;
  }

  function ajouterPalier(id, n, base){
    var lignes = [], nb = Math.max(0, Math.min(n, 2 - base));
    if (nb) lignes.push({ id: id, quantity: nb });
    if (n - nb > 0){
      var ex = { id: id, quantity: n - nb, properties: {} };
      ex.properties[EXTRA] = 'oui';
      lignes.push(ex);
    }
    return poster(lignes);
  }

  /* 18 octobre 2026, Nathanael : duo en deux couleurs. Un coussin de chaque, meme regle des
     lignes (au plus deux coussins hors extra), la remise du duo compte les deux lignes. */
  function couleur2(depuis, n){
    if (n !== 2) return null;
    var boite = depuis.closest('form') || depuis.closest('.nv-prodbloc') || document;
    var d2 = boite.querySelector('[data-nv-duo2]');
    var r = d2 && !d2.hidden && d2.querySelector('input:checked');
    return r ? r.value : null;
  }
  /* 20/10/2026, Nathanael : une seule ligne x2 (comme un duo d'une couleur), sur la couleur du
     1er coussin, et la propriete "Couleurs" visible au panier, au paiement et dans la commande. */
  function nomCouleur(boite, sel){
    var r = boite.querySelector(sel);
    var l = r && boite.querySelector('label[for="' + r.id + '"]');
    var t = l && (l.querySelector('.tt') || l);
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function ajouterDeux(depuis, id, base){
    var boite = depuis.closest('form') || depuis.closest('.nv-prodbloc') || document;
    var c1 = nomCouleur(boite, 'input[name="id"]:checked');
    var c2 = nomCouleur(boite, '[data-nv-duo2] input:checked');
    var l = { id: id, quantity: 2, properties: { 'Couleurs': c1 + ' + ' + c2 } };
    if (base >= 2) l.properties[EXTRA] = 'oui';
    return poster([l]);
  }

  /* le champ cache dans les formulaires natifs (fiche produit) */
  function champExtra(panier){
    var extra = qteBase(panier) >= 2;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
      var c = f.querySelector('input[name="properties[' + EXTRA + ']"]');
      if (extra && !c){
        c = document.createElement('input');
        c.type = 'hidden'; c.name = 'properties[' + EXTRA + ']'; c.value = 'oui';
        f.appendChild(c);
      } else if (!extra && c){ c.remove(); }
    });
  }

  /* le "+" d'une ligne de base a deux coussins : on ouvre la ligne extra */
  document.addEventListener('click', function(e){
    var plus = e.target.closest ? e.target.closest('button[name="plus"]') : null;
    if (!plus || !dernierPanier) return;
    var row = plus.closest('[data-key]');
    if (!row) return;
    var key = row.getAttribute('data-key'), it = null;
    (dernierPanier.items || []).forEach(function(x){ if (x.key === key) it = x; });
    if (!it || it.handle !== HANDLE || estExtra(it) || it.quantity < 2) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (plus.hasAttribute('disabled')) return;
    plus.setAttribute('disabled', 'disabled');
    majDebut(null);
    ajouter(it.variant_id, 1, true).then(function(r){
      if (!r.ok) throw new Error('ajout refuse');
      return r.json();
    }).then(function(){
      /* PAS rafraichirPanier() ici : il remplace #cart-drawer par une copie
         neuve, et le tiroir est OUVERT a ce moment. Le remplacer le ferme
         sans prevenir Horizon, qui laisse la page dans son etat "tiroir
         ouvert" : contenu retreci, fond noir a droite, plus de defilement.
         C'est ce qu'a vu Nathanael au premier essai. On previent Horizon
         par son propre evenement standard : chaque composant (lignes, icone,
         tiroir) se met a jour lui-meme, en place, tiroir toujours ouvert. */
      return lirePanier().then(function(c){ prevenirHorizon(c); bientot(); });
    }).catch(function(){ plus.removeAttribute('disabled'); });
  }, true);

  /* Relit seulement les sections qui portent le tiroir et son compteur.
     Le HTML complet reste le secours si Shopify ne rend pas une section.
     Les styles du panier viennent du rendu Shopify, comme dans Horizon. */
  var stylesPanierComplets = !!document.querySelector('#cart-drawer .cart__checkout-button');
  function rafraichirPanier(){
    var cibles = ['#cart-drawer', '[data-testid="cart-drawer-trigger"]'];
    var sections = [], ids = [];
    for (var i = 0; i < cibles.length; i++){
      var actuel = document.querySelector(cibles[i]);
      var section = actuel && actuel.closest('[id^="shopify-section-"]');
      if (!section) return rafraichirPanierComplet();
      var id = section.id.replace('shopify-section-', '');
      sections.push(section);
      if (ids.indexOf(id) < 0) ids.push(id);
    }
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', ids.join(','));
    return fetch(url.toString(), {
      credentials: 'same-origin', headers: { 'Accept': 'application/json' }
    }).then(function(r){
      if (!r.ok) throw new Error('sections illisibles');
      return r.json();
    }).then(function(data){
      var nouveaux = [], stylePanier = null;
      for (var j = 0; j < cibles.length; j++){
        var sid = sections[j].id.replace('shopify-section-', '');
        if (typeof data[sid] !== 'string') throw new Error('section absente');
        var doc = new DOMParser().parseFromString(data[sid], 'text/html');
        var neuf = doc.querySelector(cibles[j]);
        if (!neuf) throw new Error('element absent');
        nouveaux.push(neuf);
        if (j === 0) stylePanier = doc.querySelector('style[data-section-stylesheet]');
      }
      // Panier initialement vide : les styles du recapitulatif sont necessaires.
      // On valide tout avant de remplacer les elements, puis on garde la feuille
      // dans son wrapper de section, comme le moteur de rendu natif du theme.
      if (!stylePanier && !stylesPanierComplets) throw new Error('styles du panier absents');
      var styleActuel = sections[0].querySelector('style[data-section-stylesheet]');
      if (stylePanier && styleActuel){
        if (styleActuel.textContent !== stylePanier.textContent) styleActuel.textContent = stylePanier.textContent;
      } else if (stylePanier) { sections[0].prepend(stylePanier); }
      for (var k = 0; k < cibles.length; k++){
        document.querySelector(cibles[k]).replaceWith(nouveaux[k]);
      }
      stylesPanierComplets = true;
      observerTiroir();
    }).catch(function(){ return rafraichirPanierComplet(); });
  }

  function rafraichirPanierComplet(){
    return fetch(window.location.pathname + window.location.search, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
    .then(function(r){ if (!r.ok) throw new Error('page illisible'); return r.text(); })
    .then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* LES STYLES DU RECAPITULATIF, trouve le 13 septembre 2026 en Chrome
         pilote. Shopify ne sert qu'un SOUS-ENSEMBLE de la feuille compilee
         (styles.css?subset=...), calcule d'apres les snippets rendus sur la
         page. Panier vide au chargement : cart-summary n'est pas rendu, ses
         styles ne sont pas servis. Apres le premier ajout, le tiroir est
         remplace par sa version pleine mais la feuille, elle, restait celle
         du panier vide : recapitulatif nu, sans mise en forme. La page
         refetchee porte le bon lien : s'il differe, on l'ajoute en tete. */
      var lienNeuf = doc.querySelector('link[rel="stylesheet"][href*="compiled_assets/styles.css"]');
      if (lienNeuf){
        var href = lienNeuf.getAttribute('href'), deja = false;
        document.querySelectorAll('link[rel="stylesheet"][href*="compiled_assets/styles.css"]').forEach(function(l){
          if (l.getAttribute('href') === href) deja = true;
        });
        if (!deja){
          var l2 = document.createElement('link');
          l2.rel = 'stylesheet'; l2.media = 'screen'; l2.href = href; l2.crossOrigin = 'anonymous';
          document.head.appendChild(l2);
        }
      }
      var cibles = ['#cart-drawer', '[data-testid="cart-drawer-trigger"]'];
      var faits = 0;
      for (var i = 0; i < cibles.length; i++){
        var neuf = doc.querySelector(cibles[i]);
        var vieux = document.querySelector(cibles[i]);
        if (neuf && vieux){ vieux.replaceWith(neuf); faits++; }
      }
      if (!faits) throw new Error('tiroir introuvable');
      stylesPanierComplets = true;
      observerTiroir();
    });
  }

  function replierSurRechargement(){
    try{
      sessionStorage.setItem('nvOuvrirPanier', '1');
      sessionStorage.setItem('nvScroll', String(window.scrollY || window.pageYOffset || 0));
    }catch(err){}
    window.location.reload();
  }

  /* Annonce l'etat de l'ajout dans la live region du formulaire concerne.
     On vise le [data-nv-etat] du meme bloc d'achat, pas tous ceux de la page :
     sinon la meme phrase serait lue trois fois. */
  function etat(depuis, texte, classe){
    var boite = depuis.closest('form') || depuis.closest('.nv-prodbloc') || document;
    var zone = boite.querySelector('[data-nv-etat]');
    if (!zone) return;
    zone.className = 'nv-etat' + (classe ? ' ' + classe : '');
    zone.textContent = texte || '';
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-nv-add]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.hasAttribute('disabled')) return;
    var id = variante(b);
    if (!id){
      etat(b, "Choisissez une couleur avant d'ajouter au panier.", 'ko');
      return;
    }
    var vers = b.getAttribute('data-nv-add');
    var n = qteChoisie(b);
    var id2 = couleur2(b, n);
    b.setAttribute('disabled', 'disabled');
    etat(b, 'Ajout en cours…', 'on');
    lirePanier().catch(function(){ return dernierPanier; }).then(function(c){
      if (id2 && String(id2) !== String(id)) return ajouterDeux(b, id, qteBase(c || {}));
      return ajouterPalier(id, n, qteBase(c || {}));
    }).then(function(r){
      if (!r.ok) throw new Error('ajout refuse');
      if (vers === 'checkout'){
        etat(b, (n > 1 ? n + ' coussins ajoutés. ' : 'Ajouté au panier. ') + 'Ouverture du paiement…', 'on');
        /* 24 septembre 2026 : le code par defaut part avec, sinon le paiement
           afficherait le prix sans code alors que le palier annonce NOCTI5 */
        var codeP = null;
        try { codeP = localStorage.getItem(CODE_CLE); } catch (err) {}
        var avant = (codeP && codeP !== '-') ? fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: codeP })
        }).catch(function(){}) : Promise.resolve();
        return avant.then(function(){ window.location.href = '/checkout'; });
      }
      return rafraichirPanier().then(function(){
        b.removeAttribute('disabled');
        etat(b, n > 1 ? n + ' coussins ajoutés au panier.' : 'Ajouté au panier.', 'on');
        ouvrirTiroir();
        bientot();
      }).catch(function(){ replierSurRechargement(); });
    }).catch(function(){
      b.removeAttribute('disabled');
      etat(b, "L'ajout n'a pas fonctionné. Réessayez dans un instant.", 'ko');
    });
  });

  /* ---------- "Voir le coussin" depuis le panier vide ----------
     Si on est deja sur la page qui porte l'ancre, le navigateur ne recharge
     rien et le tiroir resterait ouvert par-dessus la fiche. On le ferme. */
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('[data-nv-voir]') : null;
    if (!a) return;
    var f = document.querySelector('#cart-drawer .theme-drawer__close-button');
    if (f) f.click();
  });

  /* ---------- deuxieme coussin, depuis le panier ---------- */
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-nv-plus]') : null;
    if (!b) return;
    e.preventDefault();
    b.setAttribute('disabled', 'disabled');
    var plus = document.querySelector('cart-quantity-selector-component button[name="plus"]')
            || document.querySelector('.cart-items button[name="plus"]')
            || document.querySelector('.cart-drawer__items button[name="plus"]');
    if (plus){ plus.click(); return; }
    var vid = b.getAttribute('data-nv-vid');
    if (!vid){ b.removeAttribute('disabled'); return; }
    ajouter(vid, 1).then(function(){
      return rafraichirPanier().then(function(){
        b.removeAttribute('disabled');
        ouvrirTiroir();
        bientot();
      }).catch(function(){ replierSurRechargement(); });
    }).catch(function(){ b.removeAttribute('disabled'); });
  });

  /* ---------- panier vide : UNE seule injection ---------- */
  function panierVide(){
    if (document.querySelector('[data-nv-vide]')) return;
    var c = document.querySelector('.cart-drawer__content')
         || document.querySelector('.cart-drawer--empty');
    if (!c) return;
    var v = clone('nvVideT');
    if (v) c.appendChild(v);
  }

  /* ---------- LE PRIX DE BASE BARRE, 13 septembre 2026 ----------
     Demande de Nathanael : le prix de base barre devant le prix paye. Sur la
     ligne, c'est en Liquid dans cart-products. Sur le total estime, c'est ici,
     depuis /cart.js (original_total_price contre total_price). Format monnaie
     calque sur celui de la boutique, symbole devant. */
  function nvEuros(c){
    /* 16 septembre 2026 : meme format que la boutique, 34,99 EUR et pas EUR34,99 */
    return (Math.round(c) / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function detaillerPrix(panier){
    /* Le total estime : le prix de base barre devant le prix paye, des qu'une
       remise (duo ou code) fait baisser le total. Pas de marque data-nv-cart,
       on ne reecrit que si ca differe, donc pas de boucle avec l'observateur.
       Le total de LIGNE barre est fait en Liquid dans cart-products (Horizon
       re-rend la ligne et ecrasait la version JS). Le bloc "detail" du pack
       duo (2 coussins x 34,99 / Pack duo) a ete retire le 13 septembre 2026
       a la demande de Nathanael. */
    var brutTotal = panier.original_total_price || 0, net = panier.total_price || 0;
    document.querySelectorAll('.cart-totals__total').forEach(function(tot){
      var val = tot.querySelector('.cart-totals__total-value');
      if (!val) return;
      var b = tot.querySelector('.nv-total-barre');
      if (brutTotal > net){
        var txt = nvEuros(brutTotal);
        if (!b){
          b = document.createElement('s');
          b.className = 'nv-total-barre';
          tot.insertBefore(b, val);
        }
        if (b.textContent !== txt) b.textContent = txt;
      } else if (b){ b.remove(); }
    });
  }

  /* ---------- mise en ordre du recapitulatif ---------- */
  function arranger(qte, vid, panier){
    detaillerPrix(panier || {});
    document.querySelectorAll('.cart-totals').forEach(function(tot){

      var total = tot.querySelector('.cart-totals__container');
      var remises = tot.querySelector('.cart-totals__original-container');
      if (!total) return;

      /* 1. la ligne livraison, SOUS le total, juste avant le bouton (au-dessus
         du bloc remises jusqu'au 13 septembre 2026, demande de Nathanael) */
      var liv = tot.querySelector('.nv-cart__liv');
      if (!liv){
        liv = document.createElement('div');
        liv.className = 'nv-cart__liv';
        liv.setAttribute('data-nv-cart', '');
        liv.innerHTML = '<span>Livraison</span><b>Offerte</b>';
        /* 18 septembre 2026 : AVANT le total, comme une ligne de recapitulatif */
        tot.insertBefore(liv, total);
      }

      /* 2. remises AVANT la ligne livraison (18 septembre 2026, demande de
         Nathanael) : sous-total, reduction, livraison, total, l'ordre d'un ticket */
      if (remises && remises.nextElementSibling !== liv){
        tot.insertBefore(remises, liv);
      }

      /* 3. (18 septembre 2026) le compte a rebours n'est plus clone ici : il est
         rendu en Liquid a cote du bouton NOCTI5, dans cart-summary. */
    });

    /* 4. moyens de paiement SOUS le bouton (au-dessus jusqu'au 13 septembre
       2026, demande de Nathanael), puis bouton renomme */
    document.querySelectorAll('.cart__ctas').forEach(function(ctas){
      var apres = ctas.nextElementSibling;
      if (!apres || !apres.classList.contains('nv-cart__pay')){
        var p = clone('nvPayT');
        if (p && ctas.parentNode) ctas.parentNode.insertBefore(p, ctas.nextSibling);
      }
      /* 18 septembre 2026 : le montant dans le bouton, "Commander · 34,99 EUR" */
      var txt = ctas.querySelector('.cart__checkout-button .button-text');
      if (txt && panier && typeof panier.total_price === 'number'){
        var voulu = 'Commander <i class="nv-cta__sep">·</i> <span class="nv-cta__total">' + nvEuros(panier.total_price) + '</span>';
        if (txt.innerHTML.replace(/\s+/g, ' ').trim() !== voulu) txt.innerHTML = voulu;
      }
    });

    /* 5. le duo, seulement si elle n'a qu'un coussin */
    if (qte !== 1) document.querySelectorAll('.nv-duo[data-nv-cart]').forEach(function(x){ x.remove(); });
    if (qte === 1){
      document.querySelectorAll('.cart-totals').forEach(function(tot){
        if (tot.previousElementSibling && tot.previousElementSibling.classList.contains('nv-duo')) return;
        var d = document.createElement('div');
        d.className = 'nv-duo';
        d.setAttribute('data-nv-cart', '');
        if (vid) d.setAttribute('data-nv-vid', vid);
        /* Le bouton seul, depuis le 13 septembre 2026 : la phrase d'explication
           et la carte grise sont parties, l'offre tient dans le libelle.
           Et depuis le meme jour il EMMENE SUR LA FICHE au lieu d'ajouter
           directement : demande de Nathanael, le lecteur choisit sa couleur
           pour le second. C'est un lien, avec data-nv-voir pour que le tiroir
           se ferme si on est deja sur la fiche (meme gestionnaire que "Voir le
           coussin" du panier vide). Le gestionnaire data-nv-plus reste en
           place, plus rien ne l'appelle. */
        d.innerHTML = '<a class="nv-duo__b" href="' + URL_FICHE + '" data-nv-voir'
                    + '>24 € de moins sur le duo</a>';
        tot.parentNode.insertBefore(d, tot);
      });
    }

    /* 6. LE COUSSIN CACHE DERRIERE LE RECAPITULATIF, corrige le 13 septembre
       2026. Horizon colle le recapitulatif (.cart-drawer__summary) en bas du
       tiroir, avec un fondu sur son bord haut, SAUF s'il occupe plus de la
       moitie du tiroir : dans ce cas cart-drawer.js pose
       cart-summary-sticky="false" sur le dialog et tout defile d'un bloc.
       Le probleme : Horizon mesure a l'ouverture, AVANT que ce script n'ajoute
       le duo, la ligne livraison, l'offre de lancement et les moyens de
       paiement. Mesure court, donc colle. Puis notre recapitulatif grandit
       jusqu'a remplir le tiroir, et la ligne du coussin, au-dessus, disparait
       derriere lui et son fondu. On refait donc la mesure d'Horizon, meme
       seuil, une fois nos ajouts en place. */
    document.querySelectorAll('#cart-drawer dialog[cart-summary-sticky]').forEach(function(dlg){
      var som = dlg.querySelector('.cart-drawer__summary');
      if (!som) return;
      var h = dlg.getBoundingClientRect().height;
      if (!h) return;
      var ratio = som.getBoundingClientRect().height / h;
      dlg.setAttribute('cart-summary-sticky', ratio > 0.5 ? 'false' : 'true');
    });
  }

  /* ---------- mise a jour en cours (voir le CSS nv-maj) ----------
     Debut : des qu'Horizon annonce un changement (shopify:cart:lines-update,
     shopify:cart:discount-update), ou que notre "+" intercepte part ajouter
     le coussin de plus. Fin : quand la promesse d'Horizon est tenue ET que le
     tiroir a bien ete re-rendu (une mutation vue par l'observateur), a la
     fin de la lecture qui suit. Garde-fou : 5 s, on retire quoi qu'il arrive. */
  var majEnCours = false, majHorizon = 0, majMutation = false, majGarde = null;

  function majDebut(promesse){
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    if (!majEnCours){ majEnCours = true; majMutation = false; d.classList.add('nv-maj'); }
    if (majGarde) clearTimeout(majGarde);
    majGarde = setTimeout(majFin, 5000);
    if (promesse && promesse.then){
      majHorizon++;
      promesse.then(function(){ majHorizon--; bientot(); }, function(){ majHorizon--; bientot(); });
    }
  }

  function majFin(){
    if (majGarde){ clearTimeout(majGarde); majGarde = null; }
    majEnCours = false; majHorizon = 0;
    var d = document.getElementById('cart-drawer');
    if (d) d.classList.remove('nv-maj');
  }

  function majPeutFinir(){
    return majEnCours && majHorizon <= 0 && majMutation;
  }

  document.addEventListener('shopify:cart:lines-update', function(ev){ majDebut(ev.promise); }, true);
  document.addEventListener('shopify:cart:discount-update', function(ev){ majDebut(ev.promise); }, true);

  /* ---------- BOUTON CODE, 13 septembre 2026 ----------
     [data-nv-code="NOCTI5"] : un clic pose le code sur le panier du visiteur,
     par deux chemins qui se completent. /cart/update.js avec "discount" (ce
     que fait le champ "Reduction" d'Horizon) l'ecrit sur le panier, et
     /discount/CODE pose le cookie que le paiement lit meme si le panier est
     encore vide a ce moment. Le bouton passe en "activee", et s'en souvient
     (localStorage) pour les pages suivantes. Le tiroir, s'il est ouvert,
     est prevenu pour afficher la ligne NOCTI5. */
  var CODE_CLE = 'nvCodeActive';

  function codeMarquer(b, etatCode){
    /* 17/10 : sur le duo, le bouton est neutralise par noctivelle-packs (nv-code--off), on n'y touche pas */
    if (b.classList.contains('nv-code--off')) return;
    var code = b.getAttribute('data-nv-code'), montant = b.getAttribute('data-nv-code-montant') || '5';
    b.classList.remove('on', 'ko');
    b.removeAttribute('disabled'); b.removeAttribute('aria-disabled');
    if (etatCode === 'on'){
      /* pas l'attribut disabled : le navigateur grise le bouton, on le veut
         bien blanc. Le clic est ignore par la classe. */
      b.classList.add('on');
      b.setAttribute('aria-disabled', 'true');
      b.textContent = 'Code ' + code + ' activ\u00e9, \u2212' + montant + '\u00a0\u20ac';
    } else if (etatCode === 'attente'){
      b.setAttribute('disabled', 'disabled');
      b.textContent = 'Activation\u2026';
    } else if (etatCode === 'ko'){
      b.classList.add('ko');
      b.textContent = 'Code ' + code + ' \u00e0 saisir au paiement';
    } else {
      b.textContent = 'Appuyez pour activer le code ' + code;
    }
    /* 18/10 : les prix du palier 1 coussin suivent l'etat du code (noctivelle-packs) */
    try { document.dispatchEvent(new Event('nv-code')); } catch (err) {}
  }

  function codeDejaActif(code){
    try { return localStorage.getItem(CODE_CLE) === code; } catch (err) { return false; }
  }

  function codeActiver(code){
    var parPanier = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code })
    }).then(function(r){ return r.ok; }).catch(function(){ return false; });
    var parCookie = fetch('/discount/' + encodeURIComponent(code) + '?redirect=/', { credentials: 'same-origin', redirect: 'follow' })
      .then(function(r){ return r.ok; }).catch(function(){ return false; });
    return Promise.all([parPanier, parCookie]).then(function(res){ return res[0] || res[1]; });
  }

  /* 24 septembre 2026, bug vu par Nathanael : bouton "Code NOCTI5 active"
     mais panier a 34,99. Le souvenir (localStorage) survivait au panier : un
     panier recree (commande passee, panier expire) n'a plus le code. La verite,
     c'est le panier : si le souvenir dit "active" et que le code n'y est pas,
     on le repose une fois ; si Shopify le refuse, on oublie et le bouton
     redevient "Activer". */
  var codeRepose = {};
  function codeManquant(c){
    var code = null;
    try { code = localStorage.getItem(CODE_CLE); } catch (err) {}
    if (!code || code === '-') return null;
    var la = (c.discount_codes || []).some(function(d){ return d.code && d.code.toUpperCase() === code.toUpperCase(); });
    if (la) return null;
    var cle = c.token || '-';
    if (codeRepose[cle]){
      /* '-' et pas une suppression : sinon le code par defaut (plus bas) le
         reposerait a chaque page et on reessaierait sans fin */
      try { localStorage.setItem(CODE_CLE, '-'); } catch (err) {}
      document.querySelectorAll('[data-nv-code]').forEach(function(x){ codeMarquer(x, ''); });
      return null;
    }
    codeRepose[cle] = true;
    return code;
  }

  /* pour tester : noctivelle.fr/?nvreset oublie l'activation et retire le
     code du panier, comme un visiteur qui arrive pour la premiere fois */
  if (location.search.indexOf('nvreset') !== -1){
    try { localStorage.removeItem(CODE_CLE); } catch (err) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    }).catch(function(){});
    try { history.replaceState(history.state, '', location.pathname); } catch (err) {}
  }

  /* 24 septembre 2026, CODE PAR DEFAUT (Nathanael : le prix d'un coussin barre
     comme celui du pack). Le palier "1 coussin" affiche le prix sans code et
     le prix avec NOCTI5 (noctivelle-packs). Pour que ce dernier soit le prix PAYE, le code
     est active pour tout visiteur : le souvenir est pose ici, puis
     codeManquant le pose sur le panier a la premiere lecture, et "Acheter
     maintenant" le repose juste avant le paiement.
     18 octobre 2026, Nathanael : plus de code par defaut. Le visiteur voit
     "Appuyez pour activer le code NOCTI5" et appuie lui-meme.
     18/10 (soir), bug vu par Nathanael : ceux qui etaient deja venus gardaient le
     souvenir "active" pose d'office par l'ancien code, le bouton disait "Code NOCTI5
     active" sans qu'ils aient rien fait. Une seule fois par navigateur : on oublie
     ce souvenir et on retire le code du panier. */
  try {
    if (localStorage.getItem('nvCodeV2') !== '1'){
      if (localStorage.getItem(CODE_CLE)){
        localStorage.removeItem(CODE_CLE);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: '' })
        }).catch(function(){});
      }
      localStorage.setItem('nvCodeV2', '1');
    }
  } catch (err) {}

  document.querySelectorAll('[data-nv-code]').forEach(function(b){
    codeMarquer(b, codeDejaActif(b.getAttribute('data-nv-code')) ? 'on' : '');
  });

  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-nv-code]') : null;
    if (!b || b.hasAttribute('disabled') || b.classList.contains('on')) return;
    e.preventDefault();
    var code = b.getAttribute('data-nv-code');
    codeMarquer(b, 'attente');
    codeActiver(code).then(function(ok){
      if (!ok){ codeMarquer(b, 'ko'); return; }
      try { localStorage.setItem(CODE_CLE, code); } catch (err) {}
      document.querySelectorAll('[data-nv-code="' + code + '"]').forEach(function(x){ codeMarquer(x, 'on'); });
      return lirePanier().then(function(c){ if ((c.item_count || 0) > 0) prevenirHorizon(c); bientot(); }).catch(function(){});
    });
  });

  /* ---------- lecture du panier ---------- */
  var occupe = false, minuteur = null, relire = false;

  function lire(){
    if (occupe){ relire = true; return; }
    var aTotaux = document.querySelector('.cart-totals');
    var aTiroir = document.querySelector('.cart-drawer__content, .cart-drawer--empty');
    if (!aTotaux && !aTiroir) return;
    occupe = true;
    lirePanier()
      .then(function(c){
        return normaliser(c).then(function(fait){
          if (!fait) return c;
          /* lignes remises en ordre : Horizon va re-rendre le tiroir, on garde
             l'etat de chargement jusqu'a ce nouveau rendu */
          majDebut(null); majMutation = false;
          return lirePanier().then(function(c2){ prevenirHorizon(c2); return c2; });
        });
      })
      .then(function(c){
        var code = codeManquant(c);
        if (!code) return c;
        majDebut(null); majMutation = false;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: code })
        }).then(lirePanier).then(function(c2){ if ((c2.item_count || 0) > 0) prevenirHorizon(c2); return c2; });
      })
      .then(function(c){
        champExtra(c);
        var qte = 0, vid = null;
        (c.items || []).forEach(function(it){
          if (it.handle === HANDLE){ qte += it.quantity; if (!vid) vid = it.variant_id; }
        });
        if ((c.item_count || 0) === 0){
          panierVide();
        } else {
          document.querySelectorAll('[data-nv-vide]').forEach(function(x){ x.remove(); });
        }
        arranger(qte, vid, c);
      })
      .catch(function(){})
      .then(function(){
        occupe = false;
        if (majPeutFinir()) majFin();
        if (relire){ relire = false; lire(); }
      });
  }

  /* attente groupee, 140 ms apres le dernier appel, mais jamais plus de
     180 ms apres le premier : le re-rendu d'Horizon envoie une rafale de
     mutations, et sans plafond la lecture attendait la fin de la rafale
     (350 ms de plus d'etat de chargement, mesure le 13 septembre 2026) */
  var premierAppel = 0;
  function bientot(){
    if (minuteur) clearTimeout(minuteur);
    var t = Date.now();
    if (!premierAppel) premierAppel = t;
    var attente = Math.max(0, Math.min(140, premierAppel + 180 - t));
    minuteur = setTimeout(function(){ minuteur = null; premierAppel = 0; lire(); }, attente);
  }

  document.addEventListener('DOMContentLoaded', bientot);
  window.addEventListener('load', bientot);
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('button[name="plus"], button[name="minus"], [data-testid="cart-drawer-trigger"], .cart-discount__button, .cart-discount__pill-remove')) bientot();
  });
  /* 21 septembre 2026, performance. L'observateur ecoutait TOUT le document :
     chaque mutation (hydratation d'Horizon, banniere cookies, nos propres blocs
     injectes) relancait une lecture de /cart.js. Mesure : 30 lectures au chargement
     de l'accueil. Ce qui nous interesse, c'est le re-rendu du tiroir par Horizon :
     on n'observe plus que #cart-drawer. S'il n'est pas encore dans la page, on
     attend son apparition puis on se debranche du document. */
  var observateurTiroir = null, tiroirObserve = null;
  function observerTiroir(){
    if (!('MutationObserver' in window)) return false;
    var tiroir = document.getElementById('cart-drawer');
    if (tiroir && tiroir === tiroirObserve) return true;
    if (observateurTiroir) observateurTiroir.disconnect();
    observateurTiroir = null;
    tiroirObserve = tiroir;
    if (!tiroir) return false;
    observateurTiroir = new MutationObserver(function(m){
      for (var i = 0; i < m.length; i++){
        var t = m[i].target;
        if (t && t.closest && t.closest('[data-nv-cart], .nv-duo, .nv-timer')) continue;
        if (majEnCours) majMutation = true;
        bientot();
        return;
      }
    });
    observateurTiroir.observe(tiroir, {childList:true, subtree:true});
    return true;
  }
  // Ce script est differe : le tiroir est deja lu. Sur /cart il n'existe
  // pas, donc inutile d'observer tout le document en permanence.
  observerTiroir();
  document.addEventListener('DOMContentLoaded', observerTiroir, {once:true});
  window.addEventListener('load', observerTiroir, {once:true});
  bientot();
})();
